import React, { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import * as ActionTypes from '../actions/actionTypes'
import { useEvent } from '../hooks/useEvent'
import { showToast } from '../../commonComponents/showToast'
export const useDocument = ({ actionType, tableName, containerKey }) => {
  const { isLoading, saveForm, deleteForm } = useEvent(containerKey, true)
  const dispatch = useDispatch()


  const otherActor= {
   "additionalFiscalReferences":{'frRoleCode':'FR1'},
   "additionalSupplyChainActor":{'aeoFlag':true},
   "authorization":{'authorizationType':'ACE'}
  }

  const AddItem = useCallback(async (payload, isHeader = false, callback) => {
    try {
      const response = isHeader
        ? await saveForm(payload)
        : await saveForm({
           [`${tableName}`]: [{ id: '',...(otherActor[tableName] || {}) }] }
           
           )

      if (response) {
        let id = isHeader ? response.header[tableName][0]?.id : ''

        dispatch({
          type: `ADD_ITEM_${actionType}`,
          payload: isHeader ? { id } : response,
          meta: { tableName: tableName },
        })
        callback && callback(response)
      } else {
        showToast('Something went wrong, Check your network connection!')
      }
    } catch (e) {
      console.log('catch', e)
      showToast('Something went wrong, Check your network connection!')
    }
  }, [])

  const deleteItem = useCallback(async (id, isHeader = false, callback) => {
    try {
      const response = isHeader
        ? await deleteForm(id)
        : await deleteForm({ [`${tableName}`]: [{ id }] })

      if (response) {
        const params =isHeader ? { payload: id} : {id}
           dispatch({
              type: `DELETE_ITEM_${actionType}`,
              ...params,
              meta: { tableName: tableName },
            })
            callback && callback()          
      }
    } catch (e) {
      console.log('catch', e)
      showToast('Something went wrong, Check your network connection!')
    }
  }, [])

  const updateItem = useCallback((id, payload) => {
    try {
      dispatch({
        type: ActionTypes[`UPDATE_ITEM_${actionType}`],
        id,
        payload,
        meta: { tableName: tableName },
      })
    } catch {
      console.log(e)
    }
  }, [])

  const saveItem = useCallback(async (payload) => {
    let response = null
    try {
      response = await saveForm({ [`${tableName}`]: [payload] }, false)
    } catch (e) {
      console.log(e)
    }
    return response
  }, [])

  return React.useMemo(
    () => ({ isLoading, AddItem, deleteItem, updateItem, saveItem }),
    [isLoading, AddItem, deleteItem, updateItem, saveItem]
  )
}